import { post, postExFile } from "@utils/httpUtil";
// 分页查询社区服务产品列表
export function quickServiceCommunityProduct_pageCommunityProduct(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/pageCommunityProduct`, data, config);
}
//导出列表数据
export function quickServiceCommunityProduct_export(data, config) {
  return postExFile(`/c/pc/quickServiceCommunityProduct/export`, data, config);
}
//查询社区产品详情
// export function quickServiceCommunityProduct_findById(data: Record<string | number, any>, config?: Record<string | number, any>) {
//   return post(`/c/pc/quickServiceCommunityProduct/findById`, data, config);
// }
export function quickServiceCommunityProduct_findById(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/findByProductId`, data, config);
}
//修改社区服务产品屏蔽状态
export function quickServiceCommunityProduct_updateForbid(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/updateForbid`, data, config);
}
//发管理分页列表
export function quickServiceCommunityProduct_findStatisticsProductCommunityUserPage(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/communityUser/findStatisticsProductCommunityUserPage`, data, config);
}
//分发管理分页列表导出
export function quickServiceCommunityProduct_findStatisticsProductCommunityUserPageExport(data, config) {
  return postExFile(`/c/pc/quickServiceCommunityProduct/communityUser/findStatisticsProductCommunityUserPageExport`, data, config);
}
//分发产品到社区
export function quickServiceCommunityProduct_deliverProductCommunityUser(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/communityUser/deliverProductCommunityUser`, data, config);
}
//查询分发分页列表
export function quickServiceCommunityProduct_findDeliverPage(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/communityUser/findDeliverPage`, data, config);
}
//分发管理操作记录分页列表
export function quickServiceCommunityProduct_findStatisticsProductCommunityUserOpPage(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/communityUser/findStatisticsProductCommunityUserOpPage`, data, config);
}
//分发管理操作记录明细分页列表
export function quickServiceCommunityProduct_findStatisticsProductCommunityUserRefOpPageByOpId(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/communityUser/findStatisticsProductCommunityUserRefOpPageByOpId`, data, config);
}
//分发管理操作记录分页列表导出
export function quickServiceCommunityProduct_findStatisticsProductCommunityUserOpPageExport(data, config) {
  return postExFile(`/c/pc/quickServiceCommunityProduct/communityUser/findStatisticsProductCommunityUserOpPageExport`, data, config);
}
//分页查询社区检测服务销售列表
export function quickServiceSales_pageList(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/communitySales/findDetectionConsultRecordPage`, data, config);
}
//查询社区服务产品销售记录详情
export function quickServiceSales_getById(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/communitySales/findById`, data, config);
}
//导出社区服务产品销售列表数据
export function quickServiceSales_export(data, config) {
  return postExFile(`/c/pc/quickServiceCommunityProduct/communitySales/findPageByConditionExport`, data, config);
}
//查询社区检测服务设置
export function quickServiceCommunityProduct_getConfig(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/getConfig`, data, config);
}
//编辑社区检测服务设置
export function quickServiceCommunityProduct_updateConfig(data, config) {
  return post(`/c/pc/quickServiceCommunityProduct/updateConfig`, data, config);
}